export default "__VITE_ASSET__lv9dWkiG__"